import { seoMeta } from "@/lib/ui/seo";

export function privacyHead() {
    return seoMeta({
        title: "Privacy Policy — Wags",
        description:
            "Learn how Wags collects, uses, and protects your personal information. Read our full Privacy Policy.",
        url: "/privacy",
    });
}

export function termsHead() {
    return seoMeta({
        title: "Terms of Service — Wags",
        description:
            "Read the Terms of Service for Wags, the platform that helps you discover and connect with pet breeders, shelters, and rescues.",
        url: "/terms",
    });
}
